import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImgComments = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.75 7.5C19.6875 7.5 18 5.8125 18 3.75C18 1.6875 19.6875 0 21.75 0C23.8125 0 25.5 1.6875 25.5 3.75C25.5 5.8125 23.8125 7.5 21.75 7.5ZM24 16.5C24 18.9844 21.9844 21 19.5 21H13.875L7.78125 25.3125C7.45312 25.5469 6.98438 25.5469 6.60938 25.3594C6.23438 25.1719 6 24.7969 6 24.375V21H4.5C2.01562 21 0 18.9844 0 16.5V6C0 3.51562 2.01562 1.5 4.5 1.5H16.1719C15.8906 2.20312 15.75 2.95312 15.75 3.75H4.5C3.28125 3.75 2.25 4.78125 2.25 6V16.5C2.25 17.7656 3.28125 18.75 4.5 18.75H7.125C7.73438 18.75 8.25 19.2656 8.25 19.875V22.2188L12.5625 19.1719C12.9375 18.8906 13.4062 18.75 13.875 18.75H19.5C20.7656 18.75 21.75 17.7656 21.75 16.5V9.75C22.5469 9.75 23.2969 9.60938 24 9.32812V16.5Z",
		fill: "#C5C5C5"
	})
});
export default SvgImgComments;
